// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IxMOX","content":"styles_content__mtz2g","row":"styles_row__Z-Sqv","footer":"styles_footer__qan2G","phraseLength":"styles_phraseLength__1eY4G"};